const en = {
  // Header
  nav_home: 'Home',
  nav_booking: 'Book Now',
  nav_therapists: 'Therapists',
  menu_label: 'Menu',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'Experience the Best\nThai Massage',
  hero_subtitle: 'Book a premium massage with professional therapists in Pattaya, Phuket, Bangkok, and Korat',
  hero_book_now: 'Book Now',
  hero_view_therapists: 'View Therapists',
  stat_therapists: 'Expert Therapists',
  stat_locations: 'Locations',
  stat_rating: 'Avg. Rating',

  // Features
  feature_gps_title: 'GPS Auto-Detect',
  feature_gps_desc: 'Automatically finds the nearest location from your current position',
  feature_booking_title: 'Easy Booking',
  feature_booking_desc: 'Book a massage easily in just 5 steps',
  feature_verified_title: 'Verified Therapists',
  feature_verified_desc: 'Professionally verified therapists with proven experience and reviews',

  // Nearby therapists section
  nearby_title: 'Therapists Near You',
  nearby_subtitle: 'Recommended therapists based on your GPS location',
  nearby_loading: 'Detecting your location...',
  nearby_error: 'Unable to detect your location',
  nearby_retry: 'Try Again',
  nearby_distance: '{distance}km away',
  nearby_book: 'Book Now',

  // Locations section
  section_locations_title: 'Available Locations',
  section_locations_subtitle: 'We provide services in 5 major cities in Thailand',
  loc_book: 'Book Now',

  // Courses section
  section_courses_title: 'Massage Courses',
  section_courses_subtitle: 'Explore our various massage programs',

  // Therapists section
  section_therapists_title: 'Popular Therapists',
  section_therapists_subtitle: 'Meet our top-rated therapists',
  view_all_therapists: 'View All Therapists',

  // CTA
  cta_title: 'Book Now',
  cta_subtitle: 'The best Thai massage experience awaits you',
  cta_book: 'Book Now',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. All rights reserved.',

  // Booking Steps
  step_location: 'Location',
  step_course: 'Course',
  step_therapist: 'Therapist',
  step_datetime: 'Date/Time',
  step_confirm: 'Confirm',

  // Booking - Step 1
  booking_location_title: 'Select a Location',
  booking_location_desc: 'Choose the area where you want your massage',
  gps_detect: 'Auto-detect My Location',
  gps_loading: 'Detecting location...',

  // Booking - Step 2
  booking_course_title: 'Select a Massage Course',
  booking_course_desc: 'Choose your preferred massage type and duration',
  duration_min: '{min} min',

  // Booking - Step 3
  booking_therapist_title: 'Select a Therapist',
  booking_therapist_desc: 'Therapists available in {location}',
  no_therapist: 'No therapists available for the selected location and course.',
  no_therapist_suggest: 'Please try a different course.',

  // Booking - Step 4
  booking_datetime_title: 'Select Date & Time',
  booking_datetime_desc: 'Choose your preferred date and time',
  date_select: 'Select Date',
  time_select: 'Select Time',
  time_placeholder: 'Please select a date first',
  time_notice: 'It may take up to 2 hours for the therapist to arrive depending on distance. Please choose a time with plenty of margin.',

  // Booking - Step 5
  booking_confirm_title: 'Confirm Your Booking',
  booking_confirm_desc: 'Review all information and enter your contact details',
  summary_location: 'Location',
  summary_course: 'Course',
  summary_price: 'Price',
  summary_therapist: 'Therapist',
  summary_date: 'Date',
  summary_time: 'Time',
  health_check_title: 'Health Conditions',
  health_check_desc: 'Please let us know if you have any health conditions, pain, or areas you\'d like to avoid during the massage.',
  health_check_placeholder: 'e.g. I have high blood pressure / My right shoulder is injured, please be gentle on upper body / Please skip lower back due to disc issues',
  health_check_examples: 'e.g. I have high blood pressure / My right shoulder is injured, please be gentle on upper body / Please skip lower back due to disc issues',
  contact_title: 'Contact Information',
  contact_name: 'Name',
  contact_name_placeholder: 'Enter your name',
  contact_phone: 'Phone Number',
  contact_phone_placeholder: 'Enter your phone number',
  contact_email: 'Email',
  contact_email_placeholder: 'Enter your email address',
  contact_note: 'Special Requests',
  contact_note_placeholder: 'Enter any special requests',
  required_mark: '*',

  // Navigation buttons
  btn_prev: 'Back',
  btn_next: 'Next',
  btn_complete: 'Complete Booking',

  // Therapist card
  age_suffix: ' yrs',
  experience_years: '{years} yrs exp.',

  // Therapist list page
  tl_title: 'Therapists',
  tl_subtitle: 'Meet our top therapists verified by experience and expertise',
  tab_all: 'All',

  // Confirmation page
  conf_empty_title: 'No Booking Information',
  conf_empty_desc: 'Please make a booking from the booking page.',
  conf_empty_btn: 'Book Now',
  conf_success_title: 'Booking Confirmed!',
  conf_success_subtitle: 'Your booking has been confirmed. Thank you.',
  conf_preparation_title: 'Booking Not Received',
  conf_preparation_subtitle: 'Our service is currently in preparation, so your booking is not yet confirmed. We will contact you once the service launches.',
  conf_preparation_notice: 'The service is under preparation — this booking is not a confirmed reservation.',
  conf_booking_id: 'Booking ID',
  conf_detail_title: 'Booking Details',
  conf_label_location: 'Location',
  conf_label_course: 'Massage Course',
  conf_label_price: 'Price',
  conf_label_therapist: 'Therapist',
  conf_label_date: 'Date',
  conf_label_time: 'Time',
  conf_label_email: 'Email',
  conf_label_contact: 'Contact',
  conf_label_note: 'Special Requests',
  conf_notice_title: 'Important Notice',
  conf_notice_1: 'It may take up to 2 hours for the therapist to arrive depending on distance.',
  conf_notice_2: 'Please contact us by phone for booking changes or cancellations.',
  conf_notice_3: 'Payment can be made on-site by cash or card.',
  conf_btn_home: 'Home',
  conf_btn_new: 'New Booking',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'Your browser does not support GPS.',
  GEO_PERMISSION_DENIED: 'Location access was denied. Please select a location manually.',
  GEO_POSITION_UNAVAILABLE: 'Location information is unavailable.',
  GEO_TIMEOUT: 'Location request timed out.',
  GEO_UNKNOWN: 'An unknown error occurred.',

  // SEO
  seo_home_title: 'Outcall Massage Bangkok & Thailand | Bangkok In Home Massage',
  seo_home_desc: 'Certified therapists visit your hotel or home in Bangkok, Pattaya, Phuket, Chiang Mai & Korat. Book Thai, aroma, or oil massage online in minutes.',
  seo_therapists_title: 'Outcall Massage Therapists | Bangkok In Home Massage',
  seo_therapists_desc: 'Browse certified outcall massage therapists in Bangkok, Pattaya, Phuket, Chiang Mai & Korat. View profiles, ratings and specialties to find your perfect therapist.',
  seo_booking_title: 'Book Outcall Massage Online | Bangkok In Home Massage',
  seo_booking_desc: 'Select your location, massage type and therapist to book an outcall massage in Bangkok, Pattaya, Phuket, Chiang Mai or Korat. We come to your hotel or home.',

  // Body info
  height_label: 'Height',
  weight_label: 'Weight',

  // GPS therapist list
  gps_find_nearby: 'Find nearby therapists',
  gps_nearby_active: 'Sorted by nearest location',

  // Notices
  notice_punctual: 'The therapist will visit at your reserved date and time. Please be ready on time.',
  notice_no_sexual: 'This is a professional massage service. Sexual services are strictly prohibited.',

  // Guide section
  guide_title: 'Service Guide',
  guide_subtitle: 'Please review the following information for a comfortable experience',
  guide_before_title: 'Before Your Session',
  guide_before_text: 'A light shower before the session is recommended. Please avoid scheduling immediately after meals. Service may be refused if you are intoxicated. If you have any medical conditions (high blood pressure, heart disease, etc.) or are pregnant, please note this in the special requests when booking.',
  guide_booking_title: 'Booking Info',
  guide_booking_text: 'It may take up to 2 hours for the therapist to arrive depending on distance. Please choose a time with plenty of margin. For booking changes or cancellations, please contact us by phone.',
  guide_session_title: 'During Your Session',
  guide_session_text: 'The therapist will visit your accommodation at the reserved time. If you feel any discomfort during the session, please let the therapist know immediately. This is a professional massage service. Sexual services are strictly prohibited.',
  guide_after_title: 'After Your Session',
  guide_after_text: 'Please drink plenty of water. Temporary muscle soreness or fatigue is normal and will resolve within 2-3 days. Please avoid heavy drinking and intense exercise on the day of your session.',
  guide_payment_title: 'Payment',
  guide_payment_text: 'Payment can be made on-site by cash or card.',

  // FAQ
  faq_q1: 'How does outcall massage work?',
  faq_a1: 'Select your location, choose a massage type, pick a therapist, and book a date and time. The therapist will come to your hotel or accommodation.',
  faq_q2: 'What areas do you serve?',
  faq_a2: 'We provide professional outcall massage services in Bangkok, Pattaya, Phuket, Chiang Mai, and Korat.',
  faq_q3: 'How can I change or cancel my booking?',
  faq_a3: 'Please contact us by phone for booking changes or cancellations. Payment can be made on-site by cash or card.',

  // 404
  notfound_title: 'Page Not Found',
  notfound_desc: 'The page you requested does not exist or has been moved.',
  notfound_home: 'Go to Home',
};

export default en;
